<template>
  <mia-form @submit="save">
    <mia-form-section
      title="DAT"
      description="Hier legen Sie Einstellungen für die Verwendung von DAT-Abfragen innerhalb Ihrer Carana fest."
    >
      <mia-notice
        title="DAT Abfragen"
        class="mb-6"
        permanent
      >
        <p class="py-0 my-0">
          Damit die DAT Abfragen in Carana erfolgreich durchgeführt werden können, müssen Sie das ausgewählte Produkt bei DAT aktiviert haben.
        </p>
      </mia-notice>

      <mia-form-section-grid>
        <!-- DAT Product -->
        <div>
          <mia-feature-select
            v-model="form.item_dat_product"
            label="Produkt"
            :options="datProductOptions"
            is-flat
            :errors="getErrors('item_dat_product')"
            @input="clearErrors('item_dat_product')"
          />
        </div>

        <!-- DAT ID -->
        <div>
          <mia-feature-input
            v-model="form.item_dat_id"
            label="Kundennummer"
            :errors="getErrors('item_dat_id')"
            @input="clearErrors('item_dat_id')"
          />
        </div>

        <!-- DAT Username -->
        <div>
          <mia-feature-input
            v-model="form.item_dat_username"
            label="Benutzername"
            :errors="getErrors('item_dat_username')"
            @input="clearErrors('item_dat_username')"
          />
        </div>

        <!-- DAT Password -->
        <div>
          <mia-feature-input
            v-model="form.item_dat_password"
            label="Passwort"
            type="password"
            :errors="getErrors('item_dat_password')"
            autocomplete="off"
            @input="clearErrors('item_dat_password')"
          />
        </div>

        <!-- DAT Auto Update -->
        <div>
          <mia-feature-select
            v-model="form.item_dat_autoupdate"
            label="Automatische Ausführung"
            :options="datAutoUpdateOptions"
            track-by="id"
            name-by="label"
            :errors="getErrors('item_dat_autoupdate')"
            @input="clearErrors('item_dat_autoupdate')"
          />
        </div>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <div class="flex items-center justify-between w-full">
        <mia-section-progress
          group="settingsBasics"
          page="dat"
          section="generalData"
        />

        <mia-submit-button
          :disabled="$wait.any"
          :is-loading="$wait.is('updating dat general data')"
        />
      </div>
    </template>
  </mia-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateDatGeneralData } from '@/api/settings'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import SectionProgress from '@/components/cars/edit/SectionProgress.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaSettingsBasicsServicesDatForm',

  components: {
    'mia-feature-input': FeatureInput,
    'mia-feature-select': FeatureSelect,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-notice': Notice,
    'mia-section-progress': SectionProgress,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      form: {
        item_dat_product: '',
        item_dat_id: '',
        item_dat_username: '',
        item_dat_password: '',
        item_dat_autoupdate: ''
      },
      datAutoUpdateOptions: [
        {
          id: 'Y',
          label: 'bei jeder FIN Änderung'
        },
        {
          id: 'N',
          label: 'nur manuell'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('settings', [
      'settings',
      'datProductOptions'
    ])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        this.$set(this.form, 'item_dat_product', settings.item_dat_product)
        this.$set(this.form, 'item_dat_id', settings.item_dat_id)
        this.$set(this.form, 'item_dat_username', settings.item_dat_username)
        this.$set(this.form, 'item_dat_autoupdate', settings.item_dat_autoupdate)
      }
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating dat general data')

      const [error] = await updateDatGeneralData({
        item_dat_product: this.form.item_dat_product,
        item_dat_id: this.form.item_dat_id,
        item_dat_username: this.form.item_dat_username,
        item_dat_password: this.form.item_dat_password,
        item_dat_autoupdate: this.form.item_dat_autoupdate
      })

      this.$wait.end('updating dat general data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        this.handleBackendValidationErrors(error)
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert.']
      })

      await this.$store.dispatch('settings/loadSettings')
    }
  }
}
</script>
